import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledProfileMenuVersion = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    cursor: pointer;

    .version-number {
      font-size: ${theme.typography.body.fontSize};
      font-weight: ${theme.typography.body.fontWeight};
      line-height: ${theme.typography.body.lineHeight};
      color: #0c395a;
    }

    .version-history-link {
      display: flex;
      align-items: center;
      cursor: pointer;

      i {
        color: ${theme.palette.primary.main};
      }
    }

    @media only screen and (max-width: 1095px) {
      padding: 12px;
    }

    @media only screen and (max-width: 600px) {
      .version-number {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .version-history-link {
        color: ${theme.palette.primary.main};
        font-size: ${theme.typography.captionLight.fontSize};
        font-weight: ${theme.typography.captionLight.fontWeight};
        line-height: ${theme.typography.captionLight.lineHeight};
      }
    }
  `
);
